import ModalFooter from '@components/sources/source/ModalFooter';
import React from 'react';
import DynamicInput from '@ui-library/dynamicInput';
import { FixMe } from '@utils/types';
import AddTraitInput from './addTraitInput';
import { Header, SubHeader } from '../../../style';

interface AddColumnModalProps {
  mappingState: FixMe;
}
const AddColumnModal = ({ mappingState }: AddColumnModalProps) => {
  const { setConstantConfig, validateName, constantsConfig } = mappingState;
  const [values, setValues] = React.useState(constantsConfig);
  const validate = React.useCallback(
    ({ key, value }: { key: string; value: string }) => {
      if (!key || !value) {
        return 'Should provide both key and value';
      }
      return validateName(
        key,
        null,
        values.map((v: FixMe) => v.key),
      );
    },
    [values],
  );

  return (
    <div>
      <div style={{ margin: '4px', marginBottom: '12px' }}>
        <Header>Manage constants</Header>
        <SubHeader>Add or remove constants</SubHeader>
      </div>
      <DynamicInput
        editMode
        values={values}
        renderValue={(v: FixMe) => (
          <span>
            <strong>Key:</strong> {v.key}
            <br />
            <strong>Value:</strong> {v.value}
          </span>
        )}
        inputComponent={AddTraitInput}
        onChange={setValues}
        validateInput={validate}
      />
      <ModalFooter onConfirm={() => setConstantConfig(values)} />
    </div>
  );
};

export default AddColumnModal;
